import { useState, useEffect, useRef } from "react";
import { Bell } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { api, formatDate } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

let _audioCtx = null;
function playBeep() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!_audioCtx) _audioCtx = new Ctx();
    const ctx = _audioCtx;
    if (ctx.state === "suspended") ctx.resume();
    const o = ctx.createOscillator(); const g = ctx.createGain();
    o.type = "sine"; o.frequency.value = 880; o.connect(g); g.connect(ctx.destination);
    g.gain.setValueAtTime(0.001, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.25, ctx.currentTime + 0.02);
    g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.35);
    o.start(); o.stop(ctx.currentTime + 0.36);
  } catch (e) { /* som indisponível */ }
}

export default function NotificationBell() {
  const { notifCount, refreshNotifs, user } = useAuth();
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const prevCount = useRef(notifCount);

  useEffect(() => {
    if (notifCount > prevCount.current && user?.notify_sound !== false) playBeep();
    prevCount.current = notifCount;
  }, [notifCount, user?.notify_sound]);

  const openNotifs = async (o) => {
    if (o) {
      const { data } = await api.get("/notifications");
      setItems(data);
      await api.put("/notifications/read");
      refreshNotifs();
    }
  };

  return (
    <Popover onOpenChange={openNotifs}>
      <PopoverTrigger asChild>
        <button data-testid="notifications-btn" className="relative p-2 rounded-sm text-zinc-300 hover:bg-[#1C1C24] transition-colors">
          <Bell className="h-5 w-5" />
          {notifCount > 0 && (
            <span data-testid="notif-count" className="absolute top-1 right-1 h-4 min-w-4 px-1 rounded-full bg-[#FF4D00] text-[10px] font-bold flex items-center justify-center text-white">
              {notifCount}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0 bg-[#121217] border-white/[0.08]">
        <div className="px-4 py-3 border-b border-white/[0.06] font-head font-semibold text-sm">Notificações</div>
        <div className="max-h-96 overflow-y-auto">
          {items.length === 0 && <div className="px-4 py-8 text-center text-sm text-zinc-500">Nenhuma notificação ainda.</div>}
          {items.map((n) => (
            <button
              key={n.id}
              onClick={() => { if (n.link) navigate(n.link); else if (n.event_id) navigate(`/eventos/${n.event_id}`); }}
              className="w-full text-left px-4 py-3 border-b border-white/[0.04] hover:bg-[#1C1C24] transition-colors"
            >
              <div className="flex items-start gap-2">
                {!n.read && <span className="mt-1.5 h-2 w-2 rounded-full bg-[#FF4D00] shrink-0" />}
                <div className={n.read ? "opacity-60" : ""}>
                  <div className="text-sm font-medium">{n.title}</div>
                  <div className="text-xs text-zinc-400">{n.body}</div>
                </div>
              </div>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
